import { render, staticRenderFns } from "./PieBase.vue?vue&type=template&id=8bd739c0&"
import script from "./PieBase.vue?vue&type=script&lang=js&"
export * from "./PieBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports